<template>
  <div class="cell-wrapper">
    <div class="cell-title flex">
      <div class="list-left">
        <div class="avatar-box">
          <img
            class="session-avatar"
            :src="this.$store.state.defaultAvatar.SYSTEM"
            alt
          />
        </div>
      </div>
      <div class="list-right relative">
        <div class="content-top flex justify-c_space-b">
          <p class="name text-ellipsis">通知消息</p>
          <span class="time">{{ date }}</span>
        </div>
        <div class="content-bottom flex">
          <!-- text-ellipsis -->
          <p class="lastmsg">{{ initNoticeContent }}</p>
          <span :class="initClassName"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullDate } from "../utils/date";
import { initAdminMsgContent } from "../utils/feed";
export default {
  name: "admin-notice-cell",
  props: {
    notice: Object,
  },
  computed: {
    date() {
      return getFullDate(new Date(this.notice.time * 1000));
    },
    initNoticeContent() {
      return initAdminMsgContent(this.notice.type, this.notice.content);
    },
    initClassName() {
      // console.log(this.notice)
    },
  },
};
</script>
<style scoped>
.cell-wrapper {
  background-color: #fff;
  border-bottom: 1px solid #f6f7f8;
  margin-bottom: 2px;
}

.flex {
  display: flex;
  flex-flow: row nowrap;
}

.justify-c_space-b {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.cell-title .list-left {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.list-left .avatar-box {
  position: relative;
  width: 50px;
  height: 50px;
}

.cell-wrapper .cell-title {
  min-height: 60px;
}

.cell-wrapper .cell-title:hover {
  background-color: #e5f1ff;
}

.cell-title img {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  border-radius: 50%;
  object-fit: cover;
}

.content-top .name {
  display: inline-block;
  max-width: 300px;
  margin: 0;
  vertical-align: top;
}

.content-top .time {
  color: #51555e;
  vertical-align: top;
}

.cell-title .list-right {
  width: 580px;
  padding: 5px 0;
  flex: auto;
}

.list-right .content-top {
  margin-right: 15px;
  line-height: 20px;
}

.list-right .content-bottom {
  margin-right: 15px;
  align-items: center;
}

.list-right .remove-session-btn {
  display: none;
  position: absolute;
  top: 28px;
  right: 14px;
  cursor: pointer;
  color: #409eff;
}

.cell-wrapper:hover .remove-session-btn {
  display: inline-block;
}

.remove-session-btn:hover {
  color: #ff0000;
}

.content-bottom .lastmsg {
  /* max-width: 95%; */
  line-height: 20px;
  color: #999;
}
</style>
